import { Button } from 'ca-ui';
import { VREditToolsPanel } from './edit-tools';
import { VRSaveToolsPanel } from './save-tools';

export class VRToolbar {
  constructor (vr, editor) {
    this.vr = vr;
    this.editor = editor;

    this.toolbar = $('<div class="ca-vr_editortoolbar"></div>');

    this.editTools = new VREditToolsPanel(this.vr, this.editor, this.toolbar);
    this.saveTools = new VRSaveToolsPanel(this.vr, this.editor, this.toolbar);

    this.closePopupButton = new Button({
      icon: 'window-close',
      label: 'Close Popup'
    });

    this.closePopupButton.on('click', function () {
      // run the destroy popup function in editor
      this.editor.destroyPopupPreview();
    }.bind(this));
    this.closePopupButton.hide();

    this.toolbar.append(this.closePopupButton.el);
    this.vr.wrapper.append(this.toolbar);
  }

  hideToolbarButtons () {
    if (this.editTools.undoButton !== undefined) {
      this.editTools.undoButton.hide();
    }

    if (this.editTools.redoButton !== undefined) {
      this.editTools.redoButton.hide();
    }

    this.saveTools.saveAsDraftButton.hide();
    this.saveTools.saveAndPublishButton.hide();
  }

  showToolbarButtons () {
    if (this.editTools.undoButton !== undefined) {
      this.editTools.undoButton.show();
    }

    if (this.editTools.redoButton !== undefined) {
      this.editTools.redoButton.show();
    }

    this.saveTools.saveAsDraftButton.show();
    this.saveTools.saveAndPublishButton.show();
  }

  showClosePopup () {
    this.closePopupButton.el.show();
  }

  hideClosePopup () {
    this.closePopupButton.el.hide();
  }

  // override
  openPanel () {}
}
